import React from 'react';
import infoIcon from './images/info-icon.svg';

const HeaderRemark = (props) => {
    return (
        <div className='esim-header-remark-wrapper'>
            <div
                className='esim-header-remark'
                style={{ '--header-remark-info-icon': infoIcon.bg() }}
            >
                <span> {props.headerRemark} </span>
            </div>
        </div>
    );
};

export default HeaderRemark;
